import type { Ref } from 'vue';
export const computeFormValidation = (validationList: any, formisValid: Ref<boolean>) => {
    type ValidationKey = keyof typeof validationList;
    let flag = true;
    let key: ValidationKey;
    for (key in validationList) {
      if (!validationList[key].valid) flag = false;
    }
    formisValid.value = flag;
  };